import React from 'react';
import { Redirect } from 'react-router-dom';

function FormSuccessfulCreationRedirect({ redirectToNewItemId, basePath }) {
	if (!redirectToNewItemId) return <></>;
	return <Redirect to={{ pathname: `${basePath.replace(/\/+$/, ``)}/${redirectToNewItemId}` }} push={false} />;
}

export default FormSuccessfulCreationRedirect;
